import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { contentfulViews, components } from '@glowforge/ui-common';
import { pagePropType } from 'app/common/selectors/page';

const { Markdown } = components;
const { Page } = contentfulViews;

// Helper to extract content from support pages manual entry
// Don't want to duplicate copy in Contentful
// Implemented as CustomWidget with a Support TextAndMedia entry in sections.
const SupportEntryTextAndMedia = ({ sections, className }) => {
  const text = _.get(sections, '[0].fields.text');
  return (
    <div className={className}>
      <Markdown className='paragraph' source={text} />
    </div>
  );
};

SupportEntryTextAndMedia.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    fields: PropTypes.shape({
      text: PropTypes.string,
    }),
  })),
  className: PropTypes.string,
};

SupportEntryTextAndMedia.defaultProps = {
  sections: [],
  className: '',
};

// Manual page
const ManualPage = ({ page }) => {
  const customSections = {
    'support-entry-text-and-media': {
      component: SupportEntryTextAndMedia,
    },
  };

  return <Page {...page} customSections={customSections} />;
};

ManualPage.propTypes = {
  page: PropTypes.shape(pagePropType).isRequired,
};


export default ManualPage;



// WEBPACK FOOTER //
// ./app/components/product/manual-page.jsx